import script from "./imgDigitalAvatarVid.vue?vue&type=script&setup=true&lang=ts"
export * from "./imgDigitalAvatarVid.vue?vue&type=script&setup=true&lang=ts"

import "./imgDigitalAvatarVid.vue?vue&type=style&index=0&id=23891330&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23891330"]])

export default __exports__